import { render, staticRenderFns } from "./DealerDetailsRightDealer.vue?vue&type=template&id=0242b522&scoped=true"
import script from "./DealerDetailsRightDealer.vue?vue&type=script&lang=js"
export * from "./DealerDetailsRightDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0242b522",
  null
  
)

export default component.exports